import {
  ContentWrapper,
  InnerWrapper,
  SwitchWrapper,
  TabsWrapper,
  TopWrapper,
} from "./styled";
import Tabs from "../../../../../../library/tabs";
import { useState } from "react";
import Animation from "./animation";
import Appearance from "./appearance";
import { useSettings } from "../../context";
import NotSelectedView from "./not-selected";
import { useTimelineContext } from "../../remotion-timeline/context/use-timeline-context";
import Switch from "../../../../../../library/switch";

const Configuration = () => {
  const { selectedItem } = useTimelineContext();
  const { applyToAll, setApplyToAllForCurrentItem } = useSettings();
  const [activeTab, setActiveTab] = useState<string>("appearance");

  const SELECTIONS = [
    {
      id: 0,
      key: "appearance",
      title: "Utseende",
      ariaLabel: "Utseende",
      display: <Appearance />,
    },
    {
      id: 1,
      key: "shared",
      title: "Animasjon",
      ariaLabel: "Animasjon",
      display: <Animation />,
    },
  ];

  const handleApplyToAllChange = () => {
    setApplyToAllForCurrentItem(!applyToAll);
  };

  return (
    <ContentWrapper>
      {selectedItem ? (
        <InnerWrapper>
          <TopWrapper>
            <SwitchWrapper>
              <Switch
                checked={applyToAll}
                onChange={handleApplyToAllChange}
                label="Bruk på alle"
                size="small"
              />
            </SwitchWrapper>
          </TopWrapper>
          <TabsWrapper>
            <Tabs
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              selections={SELECTIONS}
              variant="primary"
            />
          </TabsWrapper>
        </InnerWrapper>
      ) : (
        <NotSelectedView />
      )}
    </ContentWrapper>
  );
};

export default Configuration;
